module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/instagram/suns_sns_04-d86092e6a182e12156fd80adb9a15675.jpg";